// extracted by mini-css-extract-plugin
export default {"product_images":"ShowImage_product_images__lqJdl","img":"ShowImage_img__D4bS2"};